import React from 'react';
import { Drawer as MuiDrawer } from '@mui/material';
import CategorySwitches from './CategorySwitches';

const Drawer = ({ additives, categories, activeCategories, onCategoryChange }) => {
  return (
    <MuiDrawer
      variant="permanent"
      sx={{
        '& .MuiDrawer-paper': {
          width: 280,
          position: 'fixed',
          overflow: 'hidden',
          backgroundColor: '#ffffff',
        },
      }}
    >
      <CategorySwitches
        categories={categories}
        activeCategories={activeCategories}
        onCategoryChange={onCategoryChange}
      />
    </MuiDrawer>
  );
};

export default Drawer;
